export default __webpack_public_path__ + "static/media/Web-side-boob.653af92a.png";